<script setup lang="ts">
import { cn } from "@/lib/utils";
import { eventBus } from "#bb/lib/eventBus";
import { TabsContent } from "@/components/ui/tabs";

const props = defineProps<{ id: string }>();
const emit = defineEmits(["content-update"]);

/** Access the definition data from the content manager */
const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));


/** Define commands for the context menu */
const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Tab Item editors",
    commands: [
      {
        id: "edit",
        name: "Edit Tab Item",
        description: "Edit tab item settings",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: { ...definitionData.value },
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Tab Item",
    icon: "lucide:panel-top-dashed",
  },
});
</script>

<template>
  <TabsContent :value="definitionData.id" class="p-4">
    <slot />
  </TabsContent>

</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.TAB_ITEM,
  editor: () => import("#bb/components/editor/container/tab-item.vue"),
  icon: "lucide:panel-top-dashed",
  type: "Tab Item",
  description: "An individual tab that displays child blocks inside.",
  default: {
    title: "New Tab",
    children: [],
  },
  categories: ["Layout"],
  hiddenUntilFiltered: true,
};
</script>

<i18n lang="yaml">
en:
  editTabItemTitle: "Tab Item"
</i18n>
